<p style="margin-bottom: 16px !important" class="m-0 font-bold text-sm">Data feeds (0)</p>
    <div class="flex justify-center items-center bg-[#EFFFF7] border-[#1AA140] border-[1px] rounded px-5 py-1 mt-2 mb-3 cursor-pointer" (click)="addDataFeed()">
      <div class="flex items-center text-[14px] font-semibold leading-normal font-open-sans">
        <img src="assets/images/mx-import.svg" alt="">
        <span class=" text-[#1AA140] mr-3">Import Accounts Directly (Via API)</span>
      </div>
    </div>
    <div class="flex justify-center flex-col border border-[#d3dce8] rounded-lg" [ngClass]="inlineComponent ? 'margin12' : 'margin13'">
      <img class="mx-auto w-[5em]" src="assets/images/Data%20Feeds%20z_state.svg" />
      <p class="mx-auto m-0 font-semibold text-[14px] text-[#53565B]" style="line-height: 48px !important">
        No <span class="text-[#25508E] font-bold">Data Feeds</span> to show
      </p>
    </div>

    <p style="margin-bottom: 16px !important; margin-top: 24px !important" class="m-0 font-bold text-sm">Available Data feeds ({{ availableDataFeeds?.length || 0 }})</p>
    @if (availableDataFeeds && availableDataFeeds.length > 0) {
    <div class="data-feeds-grid">
      @for (item of availableDataFeeds; track item; let i = $index) {
      <div class="data-feed-card">
        <div class="flex width-100per py-3.5 justify-between items-center data-feed-item cursor-pointer" (click)="addUserAccount(item)">
          <div class="pl-3 m-0 flex items-center gap-3">
            <div>
              @if (!item?.profile_image_url) {
                <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" />
              }
              @if (item?.profile_image_url) {
                <ngx-avatars size="32" [src]="item?.profile_image_url"
                  [name]="item?.form_name"
                  [round]="false"
                  cornerRadius="8"
                  initialsSize="2"></ngx-avatars>
              }
            </div>
            <div>
              <div class="text-sm font-normal font-sans color-[#18191C]">
                {{ item?.form_name }}
              </div>
              <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">
                {{ item?.type }}
              </div>
            </div>
          </div>
          <div class="flex flex-row pr-3 items-center gap-2" style="margin-top: 6px">
            @if (!item?.vaultUserForm?.id) {
            <p class="text-center px-1 w-16 font-bold text-[10px] text-[#1AA140] rounded bg-[#DAF4F2] m-0">
              Available
            </p>
            } @if (item?.vaultUserForm?.id) {
            <p class="text-center px-1 w-16 font-bold text-[10px] text-[#DEA000] rounded bg-[#FFF2CD] m-0">
              In Use
            </p>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
